import { useCookies } from "react-cookie";
import { type CookieSettings } from "./types";
import { getDefaultNewCookieExpiration } from "./helpers";
import { CCPA_ENABLED_CROSS_DOMAIN_COOKIE } from "./constants";

export const useCCPAEnabledCrossDomainCookie = () => {
  const [cookies, setCookie] = useCookies([CCPA_ENABLED_CROSS_DOMAIN_COOKIE]);

  return {
    cookie: cookies[CCPA_ENABLED_CROSS_DOMAIN_COOKIE],
    set: (cookieSettings: Pick<CookieSettings, "enableOptOutCcpa">) =>
      setCookie(
        CCPA_ENABLED_CROSS_DOMAIN_COOKIE,
        String(cookieSettings.enableOptOutCcpa),
        {
          domain: window.location.hostname,
          expires: getDefaultNewCookieExpiration(),
          path: "/"
        }
      )
  };
};
